type ApiErrorPayload = {
    code: string;
};

type ApiErrorHandler = (payload: ApiErrorPayload) => void;

let handler: ApiErrorHandler | null = null;

// Deduplicate error emissions within a 3-second cooldown window to prevent spamming the user with the same error.
// More for 'No internet connection' errors.
const DEDUP_COOLDOWN_MS = 3000;
const lastEmittedAt: Record<string, number> = {};

/** Called by ApiErrorHandler on mount to start receiving error events. */
export const registerApiErrorHandler = (fn: ApiErrorHandler) => {
    handler = fn;
};

/** Called by ApiErrorHandler on unmount to stop receiving error events. */
export const unregisterApiErrorHandler = () => {
    handler = null;
};

/** Called by the axios response interceptor when an API error is detected. */
export const emitApiError = (payload: ApiErrorPayload) => {
    const now = Date.now();
    const lastTime = lastEmittedAt[payload.code];

    // Skip if the same error code was emitted within the cooldown window
    if (lastTime && now - lastTime < DEDUP_COOLDOWN_MS) {
        return;
    }

    lastEmittedAt[payload.code] = now;
    handler?.(payload);
};
